import ReactDOM from 'react-dom';

export var alternaClasse = async (id, classe) => {

    var e = document.getElementById(id);
    if (e) {
        if (e.classList.contains(classe)) {
            e.classList.remove(classe);
            return true;//Classe existia
        } else {
            e.classList.add(classe);
            return false;//Classe não existia
        }
    } else {
        return -1;
    }
}

export const MudaVisibilidade = async id => {
    var x = document.getElementById(id);

    if (window.getComputedStyle(x).getPropertyValue('display') == 'none') {
        ReactDOM.findDOMNode(x).style.setProperty('display', 'block');
    } else {
        ReactDOM.findDOMNode(x).style.setProperty('display', 'none');
    }


};